var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterviewFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5H8.5V9H15L17.5 11.5V2.5Z",
    fill: "#54BB9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.6667L15 9.16667H9.16665C8.70641 9.16667 8.33331 8.79357 8.33331 8.33333V3.33333C8.33331 2.8731 8.70641 2.5 9.16665 2.5H16.6666C17.1269 2.5 17.5 2.8731 17.5 3.33333V11.6667",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.5V14.1667C11.6667 14.6269 11.2936 15 10.8333 15H5L2.5 17.5V9.16671C2.5 8.70647 2.8731 8.33337 3.33333 8.33337H5",
    stroke: "#014935",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewFillIcon);
export default __webpack_public_path__ + "static/media/interview-fill-icon.43b3844a37513b171c72d7f9d5c4b250.svg";
export { ForwardRef as ReactComponent };